<template>
  <div>
    <v-menu offset-y
      :close-on-content-click='false'
      :value='showMenu'
    >
      <template v-slot:activator='{ on }'>
        <v-icon
          v-on='on'
          :small='!small'
          :x-small='small'
          @click='setupSearch'
        >
          {{ $store.state.icons.modules.inventory.icon }}
        </v-icon>
      </template>
      <wc-data-box hideToolbar>
        <v-card-text>
          Search for inventory/service
          <v-autocomplete
            ref='list'
            dense
            hide-details
            :items='items'
            item-text='description'
            item-value='id'
            return-object
            v-model='selected'
            @input='itemSelected'
          >
            <template v-slot:item='data'>
              <v-list-item-content>
                <v-list-item-title v-text='data.item.description'></v-list-item-title>
                <v-list-item-subtitle class='grey--text'>
                  {{ data.item.number }} | {{ data.item.division_obj.division }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class='grey--text'>
                  {{ data.item.estimate_price | decMoney }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-card-text>
      </wc-data-box>
    </v-menu>
  </div>
</template>

<script>
import assetsAPI from '@/modules/assets/api/inventory'
import servicesAPI from '@/modules/assets/api/services'
export default {
  name: 'wc-pick-inventory',
  props: {
    small: {
      required: false,
      type: Boolean,
      default: false
    },
    // division is the ID of the division
    division: {
      required: false,
      type: String
    }
  },
  data: () => ({
    isLoading: false,
    inventory: [],
    services: [],
    selected: null,
    showMenu: false
  }),
  computed: {
    items () {
      return this.inventory.concat(this.services)
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      let tmp = await assetsAPI.getInventory()
      this.inventory = tmp.filter(i => i.archived === false)
      let tmp2 = await servicesAPI.getServices()
      this.services = tmp2.filter(s => s.archived === false)
      this.isLoading = false
    },
    setupSearch () {
      this.selected = null
      this.showMenu = true
      setTimeout(() => {
        this.$refs.list.focus()
      }, 100)
    },
    itemSelected () {
      this.$emit('selected', this.selected)
      this.showMenu = null
    }
  }
}
</script>
